import { render } from "./CompanySubmenu.vue?vue&type=template&id=727c278d&scoped=true"
import script from "./CompanySubmenu.vue?vue&type=script&lang=js"
export * from "./CompanySubmenu.vue?vue&type=script&lang=js"

import "./CompanySubmenu.vue?vue&type=style&index=0&id=727c278d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727c278d"]])

export default __exports__